import util from "@/util";
import $models from '@/models'
import $api from '.'

import { goal_instantiate, accept_or_decline_invitation } from './goal'
import { instantiate_commitment_from_template } from "@/models/commitment/util";
import sequenceModelDefinition from '@/models/sequence'
import { MAGIC_UID_TEAM } from './task'

const $commitment = $models.commitment;
const $commitmentMeta = $models.commitmentMeta;
// const $commitmentSession = $models.commitmentSession;
// const $commitmentTaskEndDate = $models.commitmentTaskEndDate;
const $userCommitmentSettings = $models.userCommitmentSettings;
// const $goalMeta = $models.goalMeta;

/* =========================== Helper functions ============================= */

const DELETE_MODE = "hard";
const USE_BACKEND = 'REALTIMEDB'

const log = (...args) => { console.log("[API:commitment]", ...args) };
// const log = () => {};

/* =========================== Helper functions ============================= */

function get_last_sortidx_for_commitments( goal_id ) {
  /*
  let commitments = $store.getters['commitment/commitment_list_by_goal_id'](goal_id);
  if (!commitments || commitments.length === 0) {
    return 100;
  } else {
    let last_commitment = commitments.reduce((p, v) => (p.sortidx > v.sortidx ? p : v));
    return last_commitment.sortidx + 100;
  }
  */
  /*
  let goal_meta = $goalMeta.getNode( goal_id )
  if ( !goal_meta.$ready ) {
    console.warn("Can not get sortidx, if goal is not loaded");
    return 0;
  }
  let last_sort_idx = goal_meta.lanes_sort_indices.reduce((p, v) => ( p > v ? p : v ) )
  return last_sort_idx + 100;
  */

  let commitment_meta_list = $commitmentMeta
                            .with({ goalId: goal_id })
                            .getList();

  // TODO: Does not work yet! For some reason data is not ready, ... maybe waiting for 'add'?

  /*
  if ( !commitment_meta_list.$readyAll ) {
    console.warn("Can not get sortidx, if goal is not loaded");
    return 0;
  }
  */

  let array = commitment_meta_list.itemsAsArray();

  if ( array.length > 0 ) {
    let last_sort_idx = array.reduce((p, v) => ( p.sortidx  > v.sortidx  ? p : v ) )
    return last_sort_idx.sortidx + 100;
  } else {
    return 100;
  }
}

/* export function get_last_sortidx_for_lanes(goal_id) {
  let lanes = $store.getters['goal/get_lanes_by_goal_id'](goal_id);
  if (!lanes || lanes.length === 0) {
    return 100;
  } else {
    let last_lane = lanes.reduce((p, v) => (p.sortidx > v.sortidx ? p : v));
    return last_lane.sortidx + 100;
  }
} */

function get_last_prioidx_for_commitments( tsc_id ) {
  let commitment_user_settings_list = $userCommitmentSettings
                            .with({ timeslotCollectionId: tsc_id })
                            .getList();

  let array = commitment_user_settings_list.itemsAsArray();

  if ( array.length > 0 ) {
    let last_sort_idx = array.reduce((p, v) => ( p.sortidx  > v.sortidx  ? p : v ) )
    return last_sort_idx.sortidx + 100;
  } else {
    return 100;
  }
}

// -----------------------------------------------------------------------------

/*
  add a commitment
*/
export function commitment_create({ type, goal_id, data }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  console.warn("DEPRECATED?")

  // TODO: new type / user 'BACKLOG', ...

  let memberId = data.memberId || $models.user.defaultUserId;

  if ( type === 'BACKLOG' ) {
    memberId = 'TEAM'; // TODO
  }

  let emptyCommitment = $commitment
    .with({ uid: memberId, goalId: goal_id })
    .new_from_template({
      user_id: memberId,
      type,
      goal_id,
      ...data
    })

  log("emptyCommitment", emptyCommitment);

 /* Handle sortidx */
  let sortidx = get_last_sortidx_for_commitments(goal_id);
  // emptyCommitment.sortidx = sortidx;

  log("commitment_create: submitting payload", goal_id, emptyCommitment);
  return emptyCommitment.write().then(commitment_id => {

    log("commitment_create: creating meta", commitment_id, goal_id, data, sortidx);
    let pCreateMeta = $commitmentMeta.with({ goalId: goal_id }).add({
      name:    data.name,
      sortidx: sortidx,
      user_id: memberId
    }, commitment_id )

    /* If we get a tsc_id, we should attach the commitment to the end of the tsc. */
    let prioidx = data.timeslotCollectionId
                ? get_last_prioidx_for_commitments( data.timeslotCollectionId )
                : -1;

    let pUserSettings = $userCommitmentSettings.add({
      prioidx,
      ...data
    }, commitment_id);

    // console.log("step2", commitment_id, sortidx);
    // let path = 'lanes_sort_indices.' + commitment_id;
    // $goalMeta.update( goal_id, { [path]: sortidx } )

    return Promise.all([pCreateMeta, pUserSettings])
  });

  // return $commitment.with({ goalId: goal_id }).add(emptyCommitment, { directWrite: true })
}

// -----------------------------------------------------------------------------

/*
  create new model for new commitment, that can be saved later with obj.write_with_meta( name );
*/
export function commitment_model_new({ type, goal_id, sortidx = null }) {

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  let is_backlog = ( type === 'BACKLOG' );
  let member_id = is_backlog ? MAGIC_UID_TEAM : $models.user.defaultUserId;

  let emptyCommitment = $commitment.with({
    uid: member_id,
    goalId: goal_id
  }).new_from_template({
    user_id: $models.user.defaultUserId, // createdBy...
    type,
    goal_id
  }).clone()

  /* enhance object */
  sortidx = sortidx || get_last_sortidx_for_commitments(goal_id);
  emptyCommitment.meta = $commitmentMeta
    .with({ goalId: goal_id })
    .new_from_template({
      sortidx,
      // name: 'My new commiment',
      name: '',
      user_id: member_id
    }).clone();

  if ( !is_backlog ) {
    emptyCommitment.user = $userCommitmentSettings.new_from_template();
  }

  emptyCommitment.write_with_meta = function() {
    return this.write().then(commitment_id => {
      this.meta.$id = commitment_id;
      if ( !is_backlog) {
        this.user.$id = commitment_id; // !!!
      }
      return Promise.all([
        this.meta.write(),
        !is_backlog ? this.user.write() : null
      ]).then(() => {
        return commitment_id;
      })
    });
  }
  return emptyCommitment
}

/*
  create model from existing commitment, that can be saved later with obj.write_with_meta( name );
*/
export function commitment_model_existing({ member_id, goal_id, commitment_id } ) {

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  let is_backlog = ( member_id === MAGIC_UID_TEAM );
  // let member_id = is_backlog ? MAGIC_UID_TEAM : $models.user.defaultUserId;

  let emptyCommitment = $commitment
    .with({ goalId: goal_id, uid: member_id })
    .getNode( commitment_id )
    .clone();

  /* enhance object */
  emptyCommitment.meta = $commitmentMeta
    .with({ goalId: goal_id })
    .getNode( commitment_id )
    .clone();

  if ( !is_backlog ) {
    let model = $userCommitmentSettings.getNode( commitment_id )
    if ( model ) {
      emptyCommitment.user = model.clone();
    } else {
      // TODO: Handle other users!
      // It is possible that a user does not have a commitment setting,
      // create empty settings
      emptyCommitment.user = $userCommitmentSettings.new_from_template()
    }
  }

  emptyCommitment.write_with_meta = function() {
    return this.write().then(commitment_id => {
      return Promise.all([ this.meta.write(), !is_backlog ? this.user.write() : null ])
    });
  }
  return emptyCommitment
}

// -----------------------------------------------------------------------------

/*
  Update commmitment
  */
export function commitment_update({ commitment_id, goal_id, data }) { // <OK>

  console.warn("DEPRECATED? (memberId, TEAM)")

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid commitment_id', commitment_id)
  }

  /* Convert 'moment' to firestore 'Timestamp' */
  // TODO: Only accepts moment()
  if ( 'startDate' in data && data.startDate !== null ) {
    data.startDate = data.startDate.toBackend(USE_BACKEND);
  }

  if ( 'endDate' in data && data.endDate !== null ) {
    data.endDate = data.endDate.toBackend(USE_BACKEND);
  }

  log("commitment_update: submitting payload", data);
  return $commitment.with({ goalId: goal_id }).update( commitment_id, data )
}

// -----------------------------------------------------------------------------

export function commitment_delete({ commitment_id, goal_id, is_backlog }, delete_mode ) { // <OK>

  const DELETE_ALL_TASKS_WHEN_DELETING_COMMITMENT = true;

  // TODO: USER COMMITMENT WIRD NICHT IMMER GELÖSCHT !!!!

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid commitment_id', commitment_id)
  }

  // if ( !util.isValidId( member_id ) && member_id !== MAGIC_UID_TEAM ) {
  //   throw new Error('Invalid member_id', member_id)
  // }

  let member_id = is_backlog ? MAGIC_UID_TEAM : $models.user.defaultUserId;
  delete_mode = delete_mode === undefined ? DELETE_MODE : delete_mode;

  function delete_all_tasks(soft_delete) {
    /* Delete tasks */
    let pDeleteAllTasks = Promise.resolve()
    let all_tasklists = $models.task
      .with({ goalId: goal_id })
      .get_lane_task_list(false)

    pDeleteAllTasks = all_tasklists.$promise.then(() => {

      let tasklist_meta = all_tasklists.items[ commitment_id ] || []; // ??
      let tasklist_promises = tasklist_meta.map( task_meta => { // TODO: Hier kam fehler map of undefined
        return $api.task_delete({
          task_id:   task_meta.$id,
          goal_id:   goal_id,
          member_id: task_meta.memberId, // ?
          soft_delete: soft_delete });
      })

      return Promise.all(tasklist_promises)
    })
    return pDeleteAllTasks;
  }

  log("commitment_delete: deleting committment with tasks", delete_mode);
  if ( delete_mode === 'soft' ) {

    return $commitmentMeta
      .with({ goalId: goal_id })
      .remove( commitment_id, true )
      .then(() => {
        return delete_all_tasks(true)
      })

  } else {

    return $commitment
           .with({ goalId: goal_id, uid: member_id })
           .remove(commitment_id, false)
           .then(() => {

      /* Delete meta data too */
      let pDeleteMeta = $commitmentMeta.with({ goalId: goal_id }).remove( commitment_id )

      /* Delete user settings too */
      let pDeleteUserSettings = is_backlog
        ? Promise.resolve()
        : $userCommitmentSettings.remove( commitment_id );

      let pDeleteAllTasks = DELETE_ALL_TASKS_WHEN_DELETING_COMMITMENT
        ? delete_all_tasks(false)
        : Promise.resolve();

      // TODO Also allow to move all tasks to another commitment

      return Promise.all([pDeleteMeta, pDeleteUserSettings, pDeleteAllTasks])
    })

  }
}

// -----------------------------------------------------------------------------

export function commitment_move_batch({ batch, goal_id }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  // return $commitment.with({ goalId: goal_id }).reorder( batch )
  return $commitmentMeta.with({ goalId: goal_id }).reorder( batch )
}

// -----------------------------------------------------------------------------

export function commitment_priorize_batch({ batch }) {

  return $userCommitmentSettings.reorder( batch, {
    overwriteSortIdxKey: 'prioidx'
  })
}

// -----------------------------------------------------------------------------

export function commitment_move_to_goal({ src_goal_id, dst_goal_id, commitment_id }) {

  // TODO: Testen !!!
  // TODO: What about tasks?
  console.warn('NOT_IMPLEMENTED');

  /*

  log("commitment_move_to_goal:", src_goal_id, dst_goal_id, commitment_id );

  if ( !util.isValidId( src_goal_id ) ) {
    throw new Error('Invalid src_goal_id', src_goal_id)
  }

  if ( !util.isValidId( dst_goal_id ) ) {
    throw new Error('Invalid dst_goal_id', dst_goal_id)
  }

  if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid commitment_id', commitment_id)
  }

  const src_context = { goalId: src_goal_id }
  const dst_context = { goalId: dst_goal_id }

  return Promise.all([
    $commitment.move(commitment_id, src_context, dst_context),
    $commitmentMeta.move(commitment_id, src_context, dst_context)
  ])

  */
}

// -----------------------------------------------------------------------------

export function commitment_export_to_json({ goal_id, commitment_id, member_id }) {

  console.log("commitment_export_to_json", goal_id, commitment_id, member_id);

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid commitment_id', commitment_id)
  }

  let currentUserId = $models.user.defaultUserId

  let userCommitmentSettings = ( member_id === currentUserId )
                             ? $userCommitmentSettings.getNode( commitment_id )
                             : { $ready: true, $state: null }
  let commitmentMeta = $commitmentMeta.with({ goalId: goal_id }).getNode( commitment_id );
  let commitment = $commitment.with({ goalId: goal_id, uid: member_id }).getNode( commitment_id );

  if ( !userCommitmentSettings.$ready
    || !commitmentMeta.$ready
    || !commitment.$ready ) {
    throw new Error("Data not ready.");
  }

  if ( commitmentMeta.assignedUserId !== currentUserId ) {
    // throw new Error('Currently only taskslist owned by you can be exported.')
    // TODO: Allow commitment from other members ( memberId should be enough )
    // TODO: Exclude userCommitmentSettings
  }

  if ( commitment.type !== 'TASKLIST' ) {
    console.warn("Currently only type TASKLIST will be 100% exported.");
  }

  // TODO: Export image too ?
  // TODO: get sequences?

  // Invalid data when importing:
  // - commitmentMeta.assignedUserId (!!)
  // - commitment.createdBy
  // - commitment.picture (?) - ok
  // - commitment.templateId - ok
  // - commitment.commitmentCategoryId - ok
  // - commitment.sequenceId - ok
  // - commitment.lastCompletedSeqItemId - ok
  // - userCommitmentSettings.timeslotCollectionId
  // - task.createdBy
  // - task.landId (!!!)
  // - task.memberId - ok
  // - task.attachments

  return new Promise((resolve, reject) => {

    let all_tasklists = $models.task
      .with({ goalId: goal_id })
      .get_lane_task_list(false)

    all_tasklists.$promise.then(() => {

      let tasklist_meta = all_tasklists.items[ commitment_id ];

      let tasklist_promises = tasklist_meta.map( task_meta => {// TODO: Hier kam fehler map of undefined
        let task = $models.task
          .with({ goalId: goal_id, memberId: task_meta.memberId })
          .getNodeFull( task_meta.$id, true, false )

        return task.$promise.then(() => {
          return {
            task_meta: task.$state,
            task_details: task.details.$state,
            // task_checklist: task.task_checklist_items.$state
          }
        })
      })

      Promise.all(tasklist_promises).then(tasklist_full => {

        let export_data = {
          type: 'goalpilot/commitment',
          version: '0.1',
          uid: $models.user.defaultUserId,
          userCommitmentSettings: userCommitmentSettings.$state,
          commitmentMeta: commitmentMeta.$state,
          commitment: commitment.$state,
          tasklist: tasklist_full,
        }

        resolve( JSON.stringify( export_data/*, null, '  '*/ ) )
      })
    })
  })
}

// -----------------------------------------------------------------------------

export function commitment_import_from_json({ goal_id, json }) {

  console.log("commitment_import_from_json", goal_id, json);

  // TODO:
  // HACK! Disable optimizer for 5 seconds
  /*
  $api.set_ready('optimizer_input', false)
  setTimeout(() => {
    $api.set_ready('optimizer_input', true)
  }, 5000)
  */

  if ( json.type !== 'goalpilot/commitment' || json.version !== '0.1') {
    throw new Error('Invalid file format')
  }

  let userId = $models.user.defaultUserId;

  // 1. Create commmitment
  let commitment = commitment_model_new({ type: json.commitment.type, goal_id });

  [ 'allowToEdit',
    'committedTimeDaily',
    'committedTimePerDay',
    'remainingTime',
    'picture',
    'sessionLength',
    'startDate' ].forEach(prop => {
    if ( json.commitment[ prop ] !== undefined ) {
      commitment[ prop ] = json.commitment[ prop ]
    }
  });

  [ 'active', 'deleted', 'name' ].forEach(prop => {
    if ( json.commitmentMeta[ prop ] !== undefined ) {
      commitment.meta[ prop ] = json.commitmentMeta[ prop ]
    }
  });

  commitment.meta.assignedUserId = userId;

  if ( json.userCommitmentSettings ) {
    [ 'showFinished', 'userLeftGroup' ].forEach(prop => {
      if ( json.userCommitmentSettings[ prop ] !== undefined ) {
        commitment.user[ prop ] = json.userCommitmentSettings[ prop ]
      }
    });
  }

  // ? commitment.meta.sortidx
  // ? commitment.user.prioidx
  // ? commitment.user.timeslotCollectionId = ""
  // ? graphicalRepresentation

  let promiseList = []

  commitment.write_with_meta().then( commitment_id => {

    (json.tasklist || []).forEach(task => {

      // 2. Create tasks
      let promiseTask = $api.task_create_user({
        goal_id:   goal_id,
        parent_id: commitment_id,
        member_id: userId,
        data:      task.task_meta
      }).then( task_id => {

        console.log("MAKING CHECKLIST", task_id, task.task_details.checklist);

        let taskChecklistModel = $models.taskChecklistItem.with({
          goalId: goal_id,
          taskId: task_id,
          uid:    userId,
        })

        // 3. Create Checklist
        return Object.keys(task.task_details.checklist || {}).map(itemId => {
          let checklistItem = task.task_details.checklist[ itemId ]
          console.log("MAKING CHECKLIST ITEM", itemId, checklistItem, taskChecklistModel);
          return taskChecklistModel.add( checklistItem )
        })
      })

      promiseList.push( promiseTask )
    });
  })

  return Promise.all(promiseList)
}

// -----------------------------------------------------------------------------

export function commitment_move_to_tsc({ dst_tsc_id, commitment_id }) {

  console.log("commitment_move_to_tsc", dst_tsc_id, commitment_id);

  if ( !util.isValidId( dst_tsc_id ) && dst_tsc_id ) {
    throw new Error('Invalid dst_tsc_id', dst_tsc_id)
  }

  if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid commitment_id', commitment_id)
  }

  const data = {
    timeslotCollectionId: dst_tsc_id || ''
  }

  return $userCommitmentSettings.update( commitment_id, data );
}

// -----------------------------------------------------------------------------

export function commitment_instantiate({ template, goal_id }) { // <OK>

  if ( template.createGoalOnInstatiation ) {

    let new_goal_id = goal_instantiate({
      template: template.goalTemplate
    });
    goal_id = new_goal_id;

  } else if ( template.joinGoalOnInstatiation ) {

    accept_or_decline_invitation({
      goal_id:    template.goalTemplate.id,
      goal_name:  template.goalTemplate.name,
      accept:     true
    });
    goal_id = template.goalTemplate.id;

  } else {

    if ( !util.isValidId( goal_id ) ) {
      throw new Error('Invalid goal_id', goal_id)
    }
  }

  let user_id = $models.user.defaultUserId;

  let emptyEffort = instantiate_commitment_from_template(
    user_id, goal_id, template, USE_BACKEND
  );

  if ( emptyEffort.commitmentTscId === 'TODO' ) {
    throw new Error('TSC-Type currently not supported');
  }

  /* Handle sortidx */
  emptyEffort.sortidx = get_last_sortidx_for_commitments(goal_id);

  log("commitment_instantiate: submitting payload", goal_id, emptyEffort);

  return $commitment
         .with({ goalId: goal_id })
         .add(emptyEffort, null, { directWrite: true });
}

// -----------------------------------------------------------------------------

export function commitment_add_template_item({ // <OK>
  goal_id,
  commitment_id,
  seq_type,
  item_type,
  data
}) {
  // TODO: Currently not used!! -> Remove?
  // TODO: Get commitment and check type

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid commitment_id', commitment_id)
  }

  // TODO ! No Validation here, use API instead
  let item = sequenceModelDefinition.schema.create({
    sequenceType: seq_type,
    itemType: item_type,
    ...data
  });

  let item_id = $commitment.with({ goalId: goal_id })._get_uid(); // TODO: OR SEQUENCE NUMBER?
  let payload = {};
  item.forEach((field, key) => {
    if ( seq_type === 'SEQUENCE_TYPE1' ) {
      payload[`sessionTemplateListType1.${item_id}.${key}`] = field[key];
    }
    if ( seq_type === 'SEQUENCE_TYPE2' ) {
      payload[`sessionTemplateListType2.${item_id}.${key}`] = field[key];
    }
  })

  log("commitment_add_template_item: submitting payload", payload);
  return $commitment.with({ goalId: goal_id }).update(commitment_id, payload);
}

// -----------------------------------------------------------------------------

export function commitment_rem_template_item({ goal_id, commitment_id, item_id, data }) { // <OK>
  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  console.error("NOT IMPLEMENTED");
}

// -----------------------------------------------------------------------------
export function commitment_update_template_item({ goal_id, commitment_id, item_id }) { // <OK>
  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  console.error("NOT IMPLEMENTED");
}

// -----------------------------------------------------------------------------
export function commitment_update_template_item_by_adding_task({ // <OK>
  goal_id,
  commitment_id,
  item_id,
  task_data
}) {
  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  if ( !util.isValidId( commitment_id ) ) {
    throw new Error('Invalid commitment_id', commitment_id)
  }

  if ( !util.isValidId( item_id ) ) {
    throw new Error('Invalid item_id', item_id)
  }

  console.error("NOT IMPLEMENTED");
  // let task = empty_session_template_item_task(task_data);
}

// -----------------------------------------------------------------------------

export function commitment_update_time_today({ goal_id, commitment_id, time }) {
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------

export function commitment_update_amount_today({ goal_id, commitment_id, amount }) {
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------

export function commitment_convert_to_user_commitment({ goal_id, commitment_id, user_id }) {
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------

export function commitment_convert_to_backlog({ goal_id, commitment_id }) {
  throw new Error('NOT_IMPLEMENTED')
}

// -----------------------------------------------------------------------------

/*
export function lane_add({ goal_id, data }) { // <OK>

  let current_user = $models.user.defaultUserId;

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Got invalid goal', goal_id)
  }

  data = data || {};
  let sortidx = data.sortidx || get_last_sortidx_for_lanes(goal_id );

  log("lane_add: submitting payload", goal_id, data);
  return $lanes
         .with({ goalId: goal_id })
         .add({ creatorUserId: current_user, sortidx, ...data });
}
*/

// -----------------------------------------------------------------------------

/*
export function lane_rem({ goal_id, lane_id }) { // <OK>

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Got invalid goal', goal_id)
  }

  return $lanes
         .with({ goalId: goal_id })
         .remove(lane_id, DELETE_MODE === 'soft')
}
*/

// -----------------------------------------------------------------------------

/*
export function lane_update({ goal_id, lane_id, data }) { // <OK>

  log("lane_update", goal_id, lane_id, data);

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Got invalid goal', goal_id)
  }

  return $lanes
         .with({ goalId: goal_id })
         .update(lane_id, data);
}
*/

// -----------------------------------------------------------------------------

/*
export function lane_move_batch({ goal_id, batch }) {

  // Input:
  // Batch should be '[{ id: id1, sortidx: 1 }, { id: id2 sortidx: 2 }, ...]'
  // or
  // [id1, id2, ...]

  if ( !util.isValidId( goal_id ) ) {
    throw new Error('Invalid goal_id', goal_id)
  }

  log("lane_move_batch",  batch);
  return $lanes.with({ goalId: goal_id }).reorder( batch )
}
*/

// -----------------------------------------------------------------------------

// commitment_create,
// commitment_update,
// commitment_delete,
// commitment_move_batch,
// commitment_instantiate,
// commitment_add_template_item,
// commitment_rem_template_item,
// commitment_update_template_item,
// commitment_update_template_item_by_adding_task,
//
// lane_add,
// lane_rem,
// lane_update,
// lane_move_batch,
